import { render } from "./AdminRadioGroup.vue?vue&type=template&id=5d0a6f02"
import script from "./AdminRadioGroup.vue?vue&type=script&lang=js"
export * from "./AdminRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__